import { Button, ButtonVariant } from '@synoptic/ui-kit/button/button.tsx';
import { useIsDesktop } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC, PropsWithChildren } from 'react';
import { useAuthGuard } from '@/components/auth-guard/auth-guard-provider.tsx';
import { useFollow, useUnfollow } from './use-toggle-follow.ts';

export const ToggleFollowButton: FC<
  PropsWithChildren<{
    userId: string;
    following: boolean;
    size?: 'small' | 'medium' | 'large';
    className?: string;
    variant?: ButtonVariant;
  }>
> = ({ userId, following, children, size, className, variant }) => {
  const isDesktop = useIsDesktop();
  const authGuard = useAuthGuard();
  const [follow] = useFollow(userId);
  const [unfollow] = useUnfollow(userId);

  const toggleFollow = !following ? follow : unfollow;

  return (
    <Button
      className={className}
      onClick={(e) => {
        e.preventDefault();
        if (authGuard()) return;

        toggleFollow();
      }}
      variant={variant || (!following ? 'primary' : 'secondary')}
      size={size || (!isDesktop ? 'small' : 'medium')}
    >
      {children || (!following ? 'Follow' : 'Following')}
    </Button>
  );
};
